/** @module csi/widget/_svg/Autospace */
define([
	"dojo/_base/lang",
	"dijit/form/ToggleButton",
	"csi/locale",
	"underscore",
	"./_Plugin",
	"./PluginFactory"
], function(lang,ToggleButton,locale,_,_Plugin,PluginFactory) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		"class": "csi-button-switch",
		pluginName: "ToggleAutospace",
		title: locale.resource("CanvasGroupLabelToggleAutospace"),

		/**
		 * Enable and disable the icon
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const _enabled = (pageObjects) => {
				return pageObjects.every((pageObject) => {
					if (pageObject.childObjects && !pageObject.isAttributePlaceholder) {
						return _enabled(pageObject.childObjects);
					}

					return pageObject.isAttributePlaceholder;
				});
			}
			const enabled = _enabled(shapes);

			if (!enabled) {
				return false;
			}
			
			const doCheck = shapes.some(shape => shape.childObjects);

			if (doCheck) {
				const _checked = (pageObjects) => {
					return pageObjects.every((pageObject) => {
						if (pageObject.childObjects && !pageObject.isAttributePlaceholder) {
							return _checked(pageObject.childObjects);
						}

						if (pageObject.childObjects && pageObject.isAttributePlaceholder) {
							return pageObject.autospace;
						}

						return false;
					});
				}
				this.set("checked", _checked(shapes));
			}

			return true;
		},

		/** on click handler */
		onClick: function() {
			const { canvasApp } = this.editor;
			canvasApp.pageApi().togglePlaceholderAutospace();
		}
	});
});
